export default "__VITE_ASSET__CcCeqHru__"